module.exports = __webpack_public_path__ + "84ffe82a7c8742f84b4fed6f9ea3badc.pdf";